// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"57":"07f87ff9","98":"6cbf6d44","312":"71ea0b75","372":"3421cba8","453":"92f39d4e","543":"711c5052","626":"4c0c4817","753":"aadc6e63","842":"8a915ec6"}[chunkId] + ".chunk.js";
};